import type { IPathBaseParam } from "./path";

import type { IApiResponse } from "@/api";
import type { IUserMeEndpoint } from "@api/users/me/types";
import { createGetApi } from "@api/util/createGetApi";
import { phoneNumberChange } from "@api/users/me/phoneNumberChange/api";
import { verifyUserEmail } from "@api/users/me/verifyUserEmail/api";
import { deleteRequests } from "@api/users/me/deleteRequests/api";

const getApis = createGetApi<
  IApiResponse<IUserMeEndpoint>,
  IPathBaseParam,
  object
>("users.me");

export const me = {
  ...getApis,
  phoneNumberChange,
  verifyUserEmail,
  deleteRequests,
};
